import { Avatar } from '@mantine/core';
import type { AdminUserDoc } from '../types/user';

type UserShape = Pick<AdminUserDoc, 'email' | 'name' | 'picture'>;

interface UserAvatarProps {
  user?: UserShape;
  size?: number | string;
  radius?: string | number;
}

function getInitials(user: UserShape): string {
  if (user.name) {
    const fromName = user.name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() ?? '')
      .join('');
    if (fromName) return fromName;
  }
  return user.email.slice(0, 2).toUpperCase();
}

export function UserAvatar({ user, size = 32, radius = 'xl' }: UserAvatarProps) {
  return (
    <Avatar src={user?.picture} size={size} radius={radius} color="bagel">
      {user ? getInitials(user) : null}
    </Avatar>
  );
}
